// Collapsible — section with a dark mono header and a light body. Used for
// every togglable section in the sidebar (Specifications, Documents,
// Chromatograms, Storage, Organize, Lifecycle).

import * as React from "react";

const ChevronTiny = ({
  size = 11,
  open,
}: {
  size?: number;
  open: boolean;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      transform: open ? "rotate(90deg)" : "none",
      transition: "transform 160ms ease",
    }}
  >
    <polyline points="9 6 15 12 9 18" />
  </svg>
);

type Props = {
  title: string;
  defaultOpen?: boolean;
  badge?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
};

export function Collapsible({
  title,
  defaultOpen = true,
  badge,
  action,
  children,
}: Props) {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <section style={{ borderTop: "1px solid var(--line)" }}>
      <header
        style={{
          padding: "11px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
          cursor: "pointer",
          background: "var(--bg-sunk)",
          borderBottom: open ? "1px solid var(--line)" : "none",
        }}
        onClick={() => setOpen((o) => !o)}
      >
        <div className="hstack" style={{ gap: 8 }}>
          <span style={{ color: "var(--ink-2)", display: "inline-flex" }}>
            <ChevronTiny open={open} />
          </span>
          <span
            className="mono"
            style={{
              fontSize: 10.5,
              color: "var(--ink)",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              fontWeight: 700,
            }}
          >
            {title}
          </span>
          {badge}
        </div>
        {action && (
          <div onClick={(e) => e.stopPropagation()}>{action}</div>
        )}
      </header>
      {open && (
        <div style={{ padding: "16px 24px 22px", background: "var(--panel)" }}>
          {children}
        </div>
      )}
    </section>
  );
}
